import { render } from "./CustomerRow.vue?vue&type=template&id=1a326f24&scoped=true&ts=true"
import script from "./CustomerRow.vue?vue&type=script&lang=ts"
export * from "./CustomerRow.vue?vue&type=script&lang=ts"

import "./CustomerRow.vue?vue&type=style&index=0&id=1a326f24&scoped=true&lang=scss"

import exportComponent from "/opt/apps/parcel4you-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a326f24"]])

export default __exports__